export default {
  label: {
    planAVisit: "Plan A Visit",
    askAQuestion: "Ask A Question",
    name: "Name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    dateOfVisit: "Date of visit",
    buildAPlaylist: "Build a playlist",
    scrollDown: "Scroll Down",
    categories: "Categories",
    featured: "Featured",
  },
  button: {
    giveOnline: "Give Online",
    close: "Close",
    sendMessage: "Send Message",
    createPlaylist: "Create playlist",
    viewMore: "View more",
    goToTop: "Go to Top",
  },
  error: {
    name: "Please enter name.",
    email: "Please enter email.",
    phone: "Please enter phone.",
    message: "Please enter message.",
    dateOfVisit: "Please enter date of visit.",
    subject: "Please enter subject.",
  },
  placeholder: {
    searchForAnswers: "Search for Answers",
  },
};
